import { api_host } from "../../common/globals/constants";

/**
 *
 * @typedef {Object} DisponibilidadObjetivo
 * @property {number} uptime
 * @property {number} downtime
 * @property {number} parcial
 * @property {number} 'no monitoreo'
 *
 * @typedef {Object} DataResponse
 * @property {Date} fecha - Fecha de los resultados de disponibilidad
 * @property {DisponibilidadObjetivo} data - Data disponibilidad
 *
 * @typedef {Object} Params
 * @param {number} objectiveId - Id del objetivo
 * @param {string} period - Periodo activo/seleccionado
 * @property {Date} - startDate
 * @property {Date} - endDate
 * @param {number} scheduleId - Horario activo/seleccionado
 *
 * @param {Params} params
 * @returns DataResponse
 *
 * @author David Maldonado
 * @version 1.0.0
 */
const getAvailabityByDay = async ({
    objectiveId,
    period,
    beginDate,
    finalDate,
    scheduleId,
}) => {
    const token = sessionStorage.getItem("key");
    const user = sessionStorage.getItem("user");
    try {
        const url = `${api_host}/reporte/online/indicadores/getDisponibilityByDay/?user=${user}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&objetivoId=${objectiveId}&token=${token}&t=${period}&fechaInicio=${beginDate}&fechaTermino=${finalDate}&periodoId=${scheduleId}`;

        return await fetch(url).then((response) => response.json());
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export { getAvailabityByDay };
